import React from "react";
import Layout from "../../../shared/Layout/Layout";
import NewsHeader from "../../../shared/Components/NewsHeader";
import FirstWorkshopDetails from "./component/FirstWorkshopDetails";

export default function FirstWorkshop() {
  return (
    <Layout>
      <NewsHeader>
        First International Impact Investment Workshop in Bangladesh
      </NewsHeader>
      <FirstWorkshopDetails />
    </Layout>
  );
}
